<template>
  <div>
	<compliance v-for="cat in items" :key="cat.category">
	  <compliance-category :cat-status="categoryFilter(cat.status)"><span class="category-item">{{cat.category}}</span></compliance-category>
	  <compliance-item v-for="item in cat.items" :key="item.display_name" :item-status="itemFilter(item.status)" :status-name="item.status">
		<router-link :to="{name: 'items', params: { items: item.route_name }, query: { id: item.id, display_name: item.display_name } }">
		<span class="display-name">{{item.display_name}}</span>
		</router-link>
	  </compliance-item>
	</compliance>

  </div>
</template>
<script>
import { Compliance, ComplianceItem, ComplianceCategory } from '@/reusable_components/compliance_sidebar'

import { mapState } from 'vuex'
import router from '../../../router'

export default {
  name: 'side-bar',
  components: {
	Compliance,
	ComplianceItem,
	ComplianceCategory
  },
  data(){
	return {
	}
  },
  computed: {
	...mapState('compliance', {
	  items: state => state.sideBarCompliances,
	}),
	currentRouteName(){
	  return this.$route.name
	}
  },
  methods: {
	categoryFilter: function (value){
	  switch(value){
		case 'Completed':
		  return 'cat-completed';
		case 'Incomplete':
		  return 'cat-incomplete';
		case 'Pending':
		  return 'cat-pending';
	  }
	},
	itemFilter: function (value){
	  switch(value){
		case 'Completed':
		  return 'item-completed';
		case 'Incomplete':
		  return 'item-incomplete';
		case 'Pending':
		  return 'item-pending';
		case 'Expired':
		  return 'item-expired';
		case 'Expiring Soon':
		  return 'item-expiring-soon';
		case 'Opted Out':
		  return 'item-opted-out';
	  }
	},
	pushRoute(name){
	  //console.log("name", name)
	  var currentRoute = this.$route.name;
	  if(currentRoute !== name){
		router.push({path: `/compliances/${name}`});
	  }
	},
  }
}
</script>
<style>
.item-name a:hover, .item-name a:focus{
  text-decoration: none;
}

/* Suppress the browser's default focus ring on mouse clicks; keyboard users
   still get it via :focus-visible. */
.compliance-item a:focus:not(:focus-visible){
  outline: none;
}

.display-name{
  padding-bottom: 2px;
}

.router-link-active .display-name{
  border-bottom: 2px solid rgb(53, 53, 53);
}
</style>